import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './ListElement.scss'

import { Link } from 'react-router-dom'
import { InlineShell } from '../Shells'

const ListElement = props => {
	const {
		shell,
		noShadow,
		title,
		desc,
		link,
		path,
		footer,
		info,
		descCenter
	} = props

	if (shell) {
		return (
			<div
				styleName="element"
				className={noShadow ? styles.noShadow : null}
			>
				<div styleName="header">
					<div styleName="title">
						<InlineShell width={100} />
					</div>
				</div>
				<div styleName="desc">
					<InlineShell width={130} />
				</div>
			</div>
		)
	}
	if (path) {
		return (
			<Link
				to={path}
				styleName="element-hover"
				className={noShadow ? styles.noShadow : null}
			>
				{title ? (
					<div styleName="header">
						<div styleName="title">{title}</div>
						{info ? <div styleName="info">{info}</div> : null}
					</div>
				) : null}
				{desc ? (
					<div styleName={descCenter ? 'desc-center' : 'desc'}>
						{desc}
					</div>
				) : null}
				{footer ? <div styleName="footer">{footer}</div> : null}
			</Link>
		)
	}
	if (link) {
		return (
			<a
				href={link}
				styleName="element-hover"
				target="_blank"
				rel="noopener"
				className={noShadow ? styles.noShadow : null}
			>
				{title ? (
					<div styleName="header">
						<div styleName="title">{title}</div>
						<div styleName="info">
							<i className="material-icons" styleName="icon">
								open_in_new
							</i>
						</div>
					</div>
				) : null}
				{desc ? (
					<div styleName={descCenter ? 'desc-center' : 'desc'}>
						{desc}
					</div>
				) : null}
				{footer ? <div styleName="footer">{footer}</div> : null}
			</a>
		)
	}
	return (
		<div styleName="element" className={noShadow ? styles.noShadow : null}>
			{title ? (
				<div styleName="header">
					<div styleName="title">{title}</div>
					{info ? <div styleName="info">{info}</div> : null}
				</div>
			) : null}
			{desc ? (
				<div styleName={descCenter ? 'desc-center' : 'desc'}>
					{desc}
				</div>
			) : null}
			{footer ? <div styleName="footer">{footer}</div> : null}
		</div>
	)
}
ListElement.propTypes = {
	title: React.PropTypes.string,
	desc: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	])
}

export default CSSModules(ListElement, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/ListElement.js